export const sortByOptions = [
  { label: 'Date updated', value: 'updatedAt' },
  { label: 'Date created', value: 'createdAt' },
  { label: '(A-Z)', value: 'asc' },
  { label: '(Z-A)', value: 'desc' },
];
